import { useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import type { RespostaLogin } from '@erp/shared';
import { Alert, Skeleton } from '@erp/ui';
import { api, mensagemErro } from '../lib/api';
import { useSessao } from '../lib/sessao';

/**
 * Entrada do suporte (link gerado no admin): troca o código de uso único, que vem no `#` e nunca
 * vai para o servidor nem para logs, pela sessão de suporte da loja.
 */
export function EntrarSuporte() {
  const { usuario, entrou } = useSessao();
  const [erro, setErro] = useState<string | null>(null);
  const feito = useRef(false);
  useEffect(() => {
    if (feito.current) return;
    feito.current = true;
    const codigo = window.location.hash.slice(1);
    history.replaceState(null, '', window.location.pathname); // tira o código da barra
    if (!codigo) {
      setErro('Link de suporte incompleto. Gere outro no admin.');
      return;
    }
    api<RespostaLogin>('/auth/suporte/entrar', { method: 'POST', json: { codigo } })
      .then((r) => {
        if (r.etapa === 'concluido') entrou(r.accessToken, r.usuario);
      })
      .catch((e: unknown) => setErro(mensagemErro(e, 'Não foi possível entrar como suporte.')));
  }, [entrou]);
  if (usuario?.suporte?.ativo) return <Navigate to="/" replace />;
  return (
    <div className="grid min-h-dvh place-items-center bg-background p-4">
      <div className="w-full max-w-sm">
        {erro ? <Alert variant="erro">{erro}</Alert> : <Skeleton className="h-24" />}
      </div>
    </div>
  );
}
